var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 5.25H40.5V0.75H36V5.25H18V0.75H13.5V5.25H4.5C2.01 5.25 0 7.26 0 9.75V54.75C0 57.24 2.01 59.25 4.5 59.25H49.5C51.99 59.25 54 57.24 54 54.75V9.75C54 7.26 51.99 5.25 49.5 5.25ZM49.5 54.75H4.5V23.25H49.5V54.75ZM49.5 18.75H4.5V9.75H13.5V14.25H18V9.75H36V14.25H40.5V9.75H49.5V18.75Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEvents);
export default __webpack_public_path__ + "static/media/ic-events.75f36f5907c2039c9cdc1d09658251a9.svg";
export { ForwardRef as ReactComponent };